"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Stepper as MantineStepper, StepperCompleted, StepperStep, factory, } from "@mantine/core";
// Global button style, must come first
import "@mantine/core/styles/UnstyledButton.layer.css";
import "@mantine/core/styles/Stepper.layer.css";
import * as styles from "./Stepper.module.css";
const Stepper = factory((props, ref) => {
    // Stepper's icon size will always be xs
    return _jsx(MantineStepper, { ...props, classNames: styles, size: "xs", ref: ref });
});
Stepper.displayName = "Stepper";
StepperStep.displayName = "StepperStep";
StepperCompleted.displayName = "StepperCompleted";
Stepper.Step = StepperStep;
Stepper.Completed = StepperCompleted;
export { Stepper };
//# sourceMappingURL=Stepper.js.map